import $ from './jquery-shim.js';

var defaultOptions = {
    instaSource: 'https://lulukushel.jp/data/insta_data.json'
}

export default class Instagram {
  constructor(options) {
      this.options = $.extend(defaultOptions, options);
  }
 getInstaFeed(dnum){
    fetch(this.options.instaSource)
    .then(response => response.json())
    .then(json => {      
      let photos = "";
      const selectedDataArea = document.getElementById("instaFeed");      
      json.sort(function(a,b) {
          return (a.order > b.order ? 1 : -1);
          });
        const maxNum = parseInt(dnum) < json.length ? dnum: json.length;
        for(let i= 0; i < maxNum; i++){
          let thisLine = json[i];
          photos += '<a href="'+thisLine.permalink+'" class="item" target="_blank"><div class="post-image" style="background-image: url('+ thisLine.media_url +')"></div><span class="insta-info"><span class="insta-inner"><i class="fa fa-heart">'+ thisLine.like_count +'</i><i class="fa fa-comment">'+ thisLine.comments_count +'</i></span></span></a>'
        }
      selectedDataArea.insertAdjacentHTML('afterBegin', photos);
      });
 }
}